import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.XS};
`

export const IconContainer = styled.div`
  color: ${Colors.Blue50};
`
